import type { Currency } from "@/features/currencies/types";
import { readListing, type ListingRelation } from "./listing-status";

const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
const NATIVE_SYMBOL_BY_CHAIN: Record<number, string> = { 1: "ETH", 137: "POL" };

/** The price unit belongs to the listing, not to the NFT's network. */
export function listingCurrencySymbol(
  listing: ListingRelation,
  currencies: Currency[] = [],
): string | null {
  const fields = readListing(listing);
  if (!fields) return null;

  const direct = fields.currency?.symbol?.trim();
  if (direct) return direct.toUpperCase();

  // Compatibility with older NFT responses that only named the token address.
  // A zero address is shared by native assets, so it also needs the chain id.
  const address = fields.currency_token_address?.trim().toLowerCase();
  if (!address) return null;
  const native = address === ZERO_ADDRESS ? NATIVE_SYMBOL_BY_CHAIN[Number(fields.chain_id)] : null;
  if (address === ZERO_ADDRESS && !native) return null;
  const matches = currencies.filter((currency) =>
    currency.contract_address?.trim().toLowerCase() === address &&
    (!native || currency.symbol?.trim().toUpperCase() === native),
  );
  return matches.length === 1 && matches[0].symbol?.trim()
    ? matches[0].symbol.trim().toUpperCase()
    : null;
}
